export class GroupSearchFormModel
{
    public search: string;
    public property_id: string;
    public include_customers: boolean;
}